class MarkerActiveStateHelper {
  static activate ($overlay) {
    if (this.$overlay) {
      this.deactivate()
    }

    this.$overlay = $overlay
    this.$overlay._tooltip.marker.setIcon('/static/images/map/marker-active.svg')
  }

  static deactivate () {
    if (!this.$overlay) {
      return
    }

    this.$overlay._tooltip.marker.setIcon('/static/images/map/marker.svg')
    this.$overlay._tooltip.hide(false)
    this.$overlay = null
  }
}

/**
 * Create singleton for handling the event state on the map
 */
class OverlayListenerService {
  static listen ($map) {
    if (!this.listener) {
      this.listener = window.google.maps.event.addListener($map, 'click', () => {
        if (!event || event.target.classList.contains('infowindow') || event.target.classList.contains('marker-year')) {
          return true
        }

        MarkerActiveStateHelper.deactivate()
      })
    }
  }
}

const OverlayConstructor = function (marker) {
  const GmapOverlay = function (marker) {
    this.marker = marker
    this.pos = marker.position
    this.content = []
  }

  GmapOverlay.prototype = new window.google.maps.OverlayView()

  GmapOverlay.prototype.onAdd = function () {
    let div = document.createElement('DIV')
    div.classList.add('infowindow')
    div.style.position = 'absolute'
    div.style.opacity = 0
    div.style.pointerEvents = 'none'

    this.div_ = div

    this._addCloseHandler()
    this._applyContent()

    this.getPanes().floatPane.appendChild(div)

    this.div_.parentNode.classList.add('infowindow-wrapper')
  }

  GmapOverlay.prototype._addCloseHandler = function () {
    const closeHandler = document.createElement('DIV')
    closeHandler.classList.add('infowindow-close')

    window.google.maps.event.addDomListener(closeHandler, 'click', (e) => {
      e.cancelBubble = true

      if (e.stopPropagation) {
        e.stopPropagation()
      }

      this.hide()
    })

    this.div_.appendChild(closeHandler)
  }

  GmapOverlay.prototype.setContent = function (elms) {
    this.content = elms

    this._applyContent()
  }

  GmapOverlay.prototype.show = function () {
    if (this.div_) {
      this.div_.style.opacity = 1
      this.div_.style.pointerEvents = 'auto'
    }

    MarkerActiveStateHelper.activate(this)
  }

  GmapOverlay.prototype.hide = function () {
    if (this.div_) {
      this.div_.style.opacity = 0
      this.div_.style.pointerEvents = 'none'
      MarkerActiveStateHelper.deactivate(this)
    }
  }

  GmapOverlay.prototype._applyContent = function () {
    if (this.div_) {
      this.content.forEach($el => {
        this.div_.appendChild($el)
      })
    }
  }

  GmapOverlay.prototype.draw = function () {
    let overlayProjection = this.getProjection()
    let position = overlayProjection.fromLatLngToDivPixel(this.pos)

    this.div_.style.left = position.x + 'px'
    this.div_.style.top = position.y + 'px'
  }

  GmapOverlay.prototype.onRemove = function () {
    this.div_.parentNode.removeChild(this.div_)
    this.div_ = null
  }

  return new GmapOverlay(marker)
}

class Tooltip {
  constructor (marker) {
    this.marker = marker
    this.$overlay = new OverlayConstructor(this.marker)
    this.$overlay._tooltip = this
  }

  setContent (content) {
    this.$overlay.setContent(content)
  }

  setMap (map) {
    this.map = map
  }

  show () {
    this.$overlay.setMap(this.map || this.marker.map)

    OverlayListenerService.listen(this.map || this.marker.map)

    setTimeout(() => {
      this.$overlay.show()
    }, 100)
  }

  hide (deep = true) {
    if (deep) {
      this.$overlay.hide()
    }

    this.$overlay.setMap(null)
  }
}

export default Tooltip



// WEBPACK FOOTER //
// ./src/components/map/tooltip.js